import {activitiesReducer} from './activities.reducer';
import {accessSettingsReducer} from '@app/private-office/modules/access-settings/store';
import {userFeature} from '@app/layout/store';
import {languageReducer} from "./language.reducer";

export const rootReducer = {
  activities: activitiesReducer,
  accessSettings: accessSettingsReducer,
  user: userFeature.reducer,
  language: languageReducer,
};
